<template>
    <div id="main">
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />
        <div class="listing-header">
            <div class="title-breadcrumb"><h1 class="title">{{ `${$t('lps')}: ${selectedLps.lps.nome}` }}</h1></div>
            <div class="header-buttons">
                <button
                    class="delete-btn"
                    type="button"
                    tag="button"
                    @click="$emit('fecharModal', true)"
                >
                    {{ $t("voltar") }}
                </button>
                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                    :disabled="contratosSelecionados.length === 0"
                >
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>

        <div class="search-and-filter">
            <div class="search-bar">
                <search-bar
                    :onSearch="debouncedOnSearch"
                    :tooltipLabel="
                        $t('msg-campo-busca-n', {
                            n: `${$t('codigo')}, ${$t('nome')}, ${$t('rsocial')}, ${$t('contrato')} e ${$t('tipo-servico')}`,
                        })
                    "
                />
            </div>
        </div>

        <div class="registry-wrapper">
            <empty-table-message v-if="isEmpty" />
            <b-table
                v-else
                :data="contratos"
                class="data-table"
                @sort="sortTable"
                backend-sorting
                checkable
                :checked-rows.sync="contratosSelecionados"
                :custom-is-checked="isRowCheckedById"
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="$t(f.label)"
                    :width="f.width"
                    :sortable="f.sortable"
                    :custom-sort="f.sortFn"
                    v-slot="props"
                >
                    <span>{{ props.row[f.key] }}</span>
                </b-table-column>
            </b-table>

            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
    </div>
</template>

<script>
import ProContratoService from '@/services/promotor/pro_cliente/ProContratoService';

export default {
    props: {
        selectedLps: {
            type: Object
        },
    },
    data() {
        return {
            service: new ProContratoService(this.$http, this.$router),
            contratos: [],
            isLoading: false,
            isEmpty: false,
            fields: [
                { key: "id", label: "codigo", width: 80, sortable: true, sortFn: null },
                { key: "nomeCliente", label: `${this.$t("cliente")} - ${this.$t("nome")}`, width: null, sortable: true, sortFn: null },
                { key: "rsocialCliente", label: `${this.$t("cliente")} - ${this.$t("rsocial")}`, width: null, sortable: true, sortFn: null },
                { key: "descricao", label: "contrato", width: null, sortable: true, sortFn: null },
                { key: "tiposervico", label: "tipo-servico", width: null, sortable: true, sortFn: null },
            ],
            contratosSelecionados: [],
            idformarecebimento: 0,
            debouncedOnSearch: null,
            queryFilter: "",
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: "descricao",
            order: "asc",
            msgs: [],

            isVenda: this.$route.meta.contexto == "vendas",
        };
    },
    created() {
        this.contratosSelecionados = this.selectedLps.lps.contratos.map(contrato => contrato);

        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1) {
                this.pagination.resetPagination = true;
            }

            this.isLoading = true;

            const sort = {
                column: this.column,
                order: this.order
            }

            const contratosLpsIds = this.selectedLps.lps.contratos.map(contrato => contrato.proContratoLps.idcontratolps);

            this.service.findByLpsId(
                this.selectedLps.lps.idlps,
                currentPage - 1,
                this.pagination.perPage,
                contratosLpsIds,
                sort,
                this.queryFilter
            )
            .then(this.mapItems)
            .then((items) => {
                this.contratos = items;
                this.isEmpty = this.contratos.length === 0;
            })
            .catch((e) => {
                this.isEmpty = true;
                this.$root.showMessage("error", "msg-erro-load");
                console.error("Erro ao carregar os dados.");
            })
            .finally(() => {
                this.isLoading = false;
                this.pagination.resetPagination = false;
            });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((proContratoLps) => {
                return {
                    id: proContratoLps.idcontratolps,
                    idcontratolps: proContratoLps.idcontratolps,
                    descricao: proContratoLps.contrato.descricao,
                    nomeCliente: proContratoLps.contrato.proCliente.nome,
                    rsocialCliente: proContratoLps.contrato.proCliente.rsocial,
                    tiposervico: proContratoLps.contrato.tiposervico.descricao,
                    contrato: proContratoLps.contrato,
                    proContratoLps,
                    situacao: proContratoLps.replicapda != 3 ? 0 : 1
                };
            });
        },
        isRowCheckedById(selecionados, linha) {
            return selecionados.proContratoLps.idcontratolps === linha.idcontratolps;
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        save() {
            this.isLoading = true;

            this.selectedLps.lps.contratos = this.contratosSelecionados;

            this.$emit('updateContratoLps', this.selectedLps);
            
            this.$emit('fecharModal', true)

            this.isLoading = false;
        }
    },
};
</script>


<style lang="scss" scoped>
#main {
    padding: 20px 20px;

    .search-and-filter {
        .search-bar {
            width: 100%;
        }
        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0;
            }
        }
    }
}
</style>